import styled, { css, keyframes } from "styled-components";
import * as h from "../../../../../ui/_themes/helpers";
import { IE11Only } from "../../../../../ui/_utils/styleUtils";

const traverse = keyframes`
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const animation = css`
  ${props =>
    !props.animationStopped &&
    css`
      animation: ${traverse} 20s linear infinite forwards;
    `};
`;

/**
 * Fix for IE11.
 * In IE 10 and 11, using vw units with 3D transforms causes unexpected behavior.
 * The animation rule therefore needs to be overridden.
 * REMOVE this query when support for IE11 drops.
 */

const traverseIEFix = keyframes`
  0% {
    margin-left: 100%;
  }
  100% {
    margin-left: -100%;
  }
`;

const animationIE11 = css`
  ${props =>
    !props.animationStopped &&
    css`
      animation: ${traverseIEFix} 20s linear infinite forwards;
    `};
`;

export const TickerText: any = styled.div`
  pointer-events: all;
  color: ${h.getColor("tickerDisplay")};
  font-weight: 400;
  white-space: nowrap;
  will-change: transform;
  ${animation};
  ${IE11Only(animationIE11)};
`;
